import { AudioSource } from 'cc';
import Game from '../../../Game';
import { VOLUME_BASE } from './AudioInspector';

export default class AudioClipItem {
    public isMuted: boolean = false;
    public audioSource: Record<string, AudioSource> = {};
    public audioLimitNum: number = 10;
    public maximumVolume: number = 300;
    private _volume: number = 1;
    private _audioName: string = '';
    private _sourceType: AudioSource.AudioSourceType = null;
    private _lastPlayedAt: number = 0;

    public get volume() {
        return this._volume;
    }

    public set volume(value: number) {
        this._volume = value;
    }

    public get audioName() {
        return this._audioName;
    }
    // Remove any extra type information after '<'
    public set audioName(name: string) {
        this._audioName = name.split('<')[0];
    }

    public get lastPlayedAt() {
        return this._lastPlayedAt;
    }

    public get type() {
        return this._sourceType;
    }

    public init(audioSource: AudioSource, name: string, volume: number) {
        this.isMuted = false;
        this.audioName = name; // Remove any extra information after '<'
        this._sourceType = audioSource?.type ?? null;
        let gameVolume: number = 0;
        if (name === '音樂') {
            gameVolume = Game.audio.musicVolume;
        } else if (name === '音效') {
            gameVolume = Game.audio.effectVolume;
        } else {
            gameVolume = audioSource.type === AudioSource.AudioSourceType.Music ? Game.audio.musicVolume : Game.audio.effectVolume;
        }
        this._volume = +((gameVolume > 0 ? volume / gameVolume : 1) * VOLUME_BASE).toFixed(0);
        this.addAudioSource(audioSource);
    }

    public addAudioSource(audioSource: AudioSource) {
        if (!audioSource) {
            return;
        }
        this.audioSource[audioSource.uuid] = audioSource;
        this._lastPlayedAt = Date.now();
    }

    public deleteAudioSource(audioSource: AudioSource) {
        if (!audioSource) {
            return;
        }
        if (audioSource.uuid in this.audioSource) {
            delete this.audioSource[audioSource.uuid];
        }
    }

    public resetVolume() {
        this.isMuted = false;
        this.volume = 100;
        this.maximumVolume = 300;
    }
}
